// extracted by mini-css-extract-plugin
export default {"container":"RefererXP_container__6z0v+","dark":"RefererXP_dark__rNF31","title":"RefererXP_title__hT0x5","bold":"RefererXP_bold__cECeK","btn":"RefererXP_btn__QPe9y"};